import { Link } from "react-router-dom";

const UPDATED = "7 October 2026";
const CONTACT = {
  company: "Futuregen Innovations Ltd",
  address: "3rd Floor, 86-90 Paul Street, London, EC2A 4NE",
  companyNo: "17063895",
  registeredIn: "England and Wales",
  email: "hello@futuregenservices.com",
  privacyEmail: "hello@futuregenservices.com",
  phone: "0113 522 2861",
  icoRef: "",
  contactNote: "This mailbox is operated by Futuregen Services Ltd and handles enquiries on behalf of both Futuregen Innovations Ltd and Futuregen Services Ltd, which are separate companies.",
};

export function LegalLayout({ title, intro, children, testId }) {
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid={testId}>
      <span className="overline text-accent">Legal</span>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mt-1 mb-3">{title}</h1>
      <p className="text-sm text-muted-foreground mb-8" data-testid="legal-meta">Last updated {UPDATED} · {CONTACT.company}, registered in {CONTACT.registeredIn}, company no. {CONTACT.companyNo}{CONTACT.icoRef && ` · ICO registration no. ${CONTACT.icoRef}`} · Registered office: {CONTACT.address}</p>
      {intro && <p className="text-muted-foreground leading-relaxed mb-8">{intro}</p>}
      <div className="prose prose-slate dark:prose-invert max-w-none prose-headings:font-display prose-h2:text-xl prose-h2:mt-10 prose-a:text-primary">{children}</div>
      <p className="mt-12 text-xs text-muted-foreground">Questions about this policy: <a href={`mailto:${CONTACT.email}`} className="text-primary hover:underline" data-testid="legal-privacy-email">{CONTACT.email}</a> · {CONTACT.phone}. {CONTACT.contactNote} See also our <Link to="/privacy" className="text-primary hover:underline">Privacy Policy</Link>, <Link to="/terms" className="text-primary hover:underline">Terms &amp; Conditions</Link> and <Link to="/cookies" className="text-primary hover:underline">Cookie Notice</Link>.</p>
    </article>
  );
}

export { CONTACT };
